import { DirectionEnum } from "../enums";
import { TypeOrmMappedOperator } from "../models";
import { PartialRecord } from "./partial-record";

export const resolveProduceButtonDirection = (
  direction: DirectionEnum | null,
): PartialRecord<TypeOrmMappedOperator, DirectionEnum | DirectionEnum[]> => {
  switch (direction) {
    case DirectionEnum.DropOff:
      return {
        $eq: DirectionEnum.DropOff,
      };

    case DirectionEnum.PickUp:
      return {
        $eq: DirectionEnum.PickUp,
      };
    case DirectionEnum.Both:
    case null:
    default:
      return {
        $in: [DirectionEnum.PickUp, DirectionEnum.DropOff],
      };
  }
};
